import React, { useContext } from 'react'
import { Redirect } from './Navigation'
import { LoadingScreen } from './LoadingScreen'
import { UseQueryResult } from '@tanstack/react-query'
import { PageContext } from '@/utils'

type ItemProps = {
  id: string | number
  [key: string]: any
}

export type DynamicPageHandlerProps = {
  item: ItemProps
  query?: UseQueryResult
  children: React.ReactNode
  // If is Server side rendering, use an different approach to handle the loading state
  isSSR?: boolean
  redirectTo?: any
  data?: any
}

export const DynamicPageHandler = (props?: DynamicPageHandlerProps) => {
  const { item, query, children, isSSR = false, redirectTo = '/404/', data } = props
  const noItem = !item

  if (isSSR && noItem) return <Redirect to={redirectTo} />

  if (noItem) {
    if (query?.isFetched || query?.isError) {
      return <Redirect to={redirectTo} />
    } else {
      // @ts-ignore
      return <LoadingScreen />
    }
  }

  return <PageContext.Provider value={data}>{children}</PageContext.Provider>
}

export default DynamicPageHandler
